export default __webpack_public_path__ + "static/media/6.bdd22899.png";